const isProduction = process.env.NODE_ENV === 'production';

export function identifyFullStoryUser(user) {
  if (!isProduction) {
    return;
  }
  if (!user || user.id == null) {
    return;
  }
  if (typeof window === 'undefined' || typeof window.FS === 'undefined' || typeof window.FS.identify !== 'function') {
    return;
  }
  window.FS.identify(String(user.id));
}

export function anonymizeFullStory() {
  if (!isProduction) {
    return;
  }
  if (typeof window === 'undefined' || typeof window.FS === 'undefined' || typeof window.FS.anonymize !== 'function') {
    return;
  }
  window.FS.anonymize();
}
